import { getAwsAssets } from "@src/utils";
import { Image } from "@src/components/Image";
import React from "react";
import Button from "@src/components/UIElements/Button";
import styles from "./FallbackComponent.module.scss";
import { useRouter } from "@src/lib/router";

const FallbackComponent = ({
  errorMessage: { imageName, heading, text, buttonText },
}) => {
  // FUNCTION TO HANDLE TRY AGAIN BUTTON CLICKED
  const router = useRouter();
  const handleTryAgainClicked = () => {
    // alert"handleTryAgainClicked");
    router?.reload();
  };

  return (
    <div className={styles.fallbackComponent}>
      {imageName && (
        <Image
          src={getAwsAssets(imageName, "errorFallbacks")}
          alt="errorThumbnail"
          width={154}
          height={158}
        />
      )}
      {heading && <h1>{heading}</h1>}
      {text && <p>{text}</p>}
      {buttonText && (
        <Button onClick={handleTryAgainClicked}>{buttonText}</Button>
      )}
    </div>
  );
};

export default FallbackComponent;
